import { NEW_FOLDER_SUBSCRIPTION } from './new-folder';
import { NEW_MESSAGE_SUBSCRIPTION } from './new-message';
import { AI_CHAT_COMPLETION_STREAM } from './ai/ai-chat-completion-stream';

const SUBSCRIPTION = {
    NEW_FOLDER_SUBSCRIPTION,
    NEW_MESSAGE_SUBSCRIPTION,
    AI_CHAT_COMPLETION_STREAM
};

export default SUBSCRIPTION;
